module.exports = __webpack_public_path__ + "img/1557614063885819905.5c7ee6af.png";